import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCtaBar from "@/components/MobileCtaBar";
import EnquiryDialog from "@/components/EnquiryDialog";
import AmbientAudio from "@/components/AmbientAudio";
import ScrollManager from "@/components/ScrollManager";
import Home from "@/pages/Home";
import StoryPage from "@/pages/StoryPage";
import StayPage from "@/pages/StayPage";
import ExperiencesPage from "@/pages/ExperiencesPage";
import WildlifePage from "@/pages/WildlifePage";
import JourneyPage from "@/pages/JourneyPage";
import GalleryPage from "@/pages/GalleryPage";
import JournalPage from "@/pages/JournalPage";
import JournalArticlePage from "@/pages/JournalArticlePage";
import PlanPage from "@/pages/PlanPage";
import PackagesPage from "@/pages/PackagesPage";
import ConservationPage from "@/pages/ConservationPage";
import PrivacyPage from "@/pages/PrivacyPage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import NotFoundPage from "@/pages/NotFoundPage";
import { initLenis, destroyLenis } from "@/lib/scroll";

function App() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollManager />
          <Header />
          <div className="pb-14 md:pb-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/story" element={<StoryPage />} />
              <Route path="/stay" element={<StayPage />} />
              <Route path="/experiences" element={<ExperiencesPage />} />
              <Route path="/wildlife" element={<WildlifePage />} />
              <Route path="/journey" element={<JourneyPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/journal" element={<JournalPage />} />
              <Route path="/journal/:slug" element={<JournalArticlePage />} />
              <Route path="/plan" element={<PlanPage />} />
              <Route path="/packages" element={<PackagesPage />} />
              <Route path="/conservation" element={<ConservationPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/disclaimer" element={<DisclaimerPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
          <Footer />
          <MobileCtaBar />
          <EnquiryDialog />
          <AmbientAudio />
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-center" />
      </div>
    </HelmetProvider>
  );
}

export default App;
